/* eslint-disable @typescript-eslint/no-unused-vars */
import { Link as RouterLink } from "react-router-dom";
import CloseIconButton from "../lib/CloseIconButton";
import {
	DialogContent,
	DialogContentText,
	Typography,
	DialogActions
} from "@mui/material";
import { useGoogleAnalyticsContext } from "contexts";
import ThemeButton from "components/Buttons/ThemeButton";
import { useImagePath } from "hooks";
import { CustomDialog, CustomDialogTitle } from "./styles";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { IPlaygamiAnalyticProps } from "interfaces/analytics/playgami";
import { useEffect } from "react";
import { useDialogModalRedux } from "redux/slices/dialog/hooks/useDialogModalRedux";

const DialogErrorInsufficientLoyaltyPointBalanceV2 = ({
	show,
	onCloseClick
}: {
	show: boolean;
	onCloseClick: () => void;
}) => {
	const { getImage } = useImagePath("local");
	const backgroundImage = getImage("spec_dialogs/oops3.png");
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { dialogState } = useDialogModalRedux();

	const scale = useCalculateScale(420, 415);

	const reportAnalytics = ({ event_name }: IPlaygamiAnalyticProps) => {
		const event_type = "insufficient_funds_dialog";
		reportPlaygamiEvent("tp.web_frontend", {
			event_name,
			event_type,
			action: event_name,
			source: event_type,
			value_int: dialogState?.NeededLoyaltyPoints,
			value_int2: dialogState?.CurrentLoyaltyPoints
		});
	};

	const onClick = () => {
		reportAnalytics({ event_name: "earn_in_store_click" });
		onCloseClick();
	};
	const onClose = () => {
		reportAnalytics({ event_name: "dialog_closed" });
		onCloseClick();
	};

	useEffect(() => {
		if (show) {
			reportAnalytics({
				event_name: "dialog_shown"
			});
		}
	}, [show]);

	return (
		<CustomDialog
			scale={scale}
			open={show}
			onClose={onClose}
			style={{ zIndex: 999999 }}
		>
			<CustomDialogTitle
				sx={{
					backgroundImage: `url(${backgroundImage})`
				}}
			>
				<CloseIconButton onClose={onClose} />
			</CustomDialogTitle>
			<DialogContent sx={{ padding: "0 15px" }}>
				<DialogContentText sx={{ padding: 0 }}>
					<Typography
						variant="h6"
						component="strong"
						sx={{
							fontFamily: "Baloo",
							fontWeight: "400",
							fontSize: "26px",
							margin: "1.3rem 0 .8rem",
							display: "block",
							textAlign: "center",
							lineHeight: 1,
							color: "#333333"
						}}
					>
						Not enough Loyalty Points
					</Typography>
					<Typography
						sx={{
							fontFamily: "Inter",
							fontWeight: "400",
							fontSize: "16px",
							//margin: "8px 0",
							display: "block",
							textAlign: "center",
							lineHeight: 1.2,
							color: "#000"
						}}
					>
						Just a few points short! Earn more by shopping in the web store and
						snag this items.
					</Typography>
				</DialogContentText>
			</DialogContent>
			<DialogActions
				sx={{
					justifyContent: "center",
					flexDirection: "column",
					height: "fit-content"
				}}
			>
				<RouterLink
					to={"/shop"}
					onClick={onClick}
					style={{
						width: "calc(100% - 3rem)",
						textDecoration: "none",
						//margin: "0.8rem",
						marginBottom: 0
					}}
				>
					<ThemeButton
						sx={{
							paddingTop: ".75rem",
							paddingBottom: ".75rem",
							marginBottom: 1.5,
							width: "100%"
						}}
					>
						Earn Loyalty Points
					</ThemeButton>
				</RouterLink>
			</DialogActions>
		</CustomDialog>
	);
};

export { DialogErrorInsufficientLoyaltyPointBalanceV2 };
